// extracted by mini-css-extract-plugin
export default {"defaultAlertBox":"Alert2_defaultAlertBox__UwlEa"};